import { FooterContext } from "@contexts/FooterContext";
import React, { useContext } from "react";

const BadgeStores = () => {
  const { appLinks } = useContext(FooterContext);

  return (
    <div className="flex items-center gap-4 md:justify-center sm:gap-3">
      <a href={appLinks?.appleAppStore} target="_blank" rel="noreferrer">
        <img
          src="/images/appStore.svg"
          alt="Apple Store"
          className="h-[36px] md:h-[47px]"
        />
      </a>
      <a href={appLinks?.googlePlay} target="_blank" rel="noreferrer">
        <img
          src="/images/googlePlay.svg"
          alt="Google Play"
          className="h-[36px] md:h-[47px]"
        />
      </a>
    </div>
  );
};

export default BadgeStores;
